<template>
  <div
    class="row"
    :style="
      context == 'gp'
        ? 'margin-top: 15px; margin-bottom: 15px'
        : 'margin-bottom: 15px'
    "
  >
    <div :class="'col-12'">
      <div style="padding-bottom: 40px">
        <div
          class="row w-100 ml-0 mr-0 totalsBoxLayout"
          style="margin: 20px auto 20px auto"
        >
          <div
            :class="context == 'gp' ? 'col-3 pl-0 pr-0' : 'col-12 pl-0 pr-0'"
          >
            <div
              class="d-flex justify-content-center"
              style="padding-top: 20px; padding-bottom: 15px"
            >
              <div class="summaryFundTitle" v-if="context == 'gp'">
                Total Distributed To Date
              </div>
              <div class="summaryFundTitle" v-if="context == 'lp'">
                Distributed
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <div class="summaryFundTitle">{{ totalDistributions }}</div>
            </div>
          </div>
          <div class="col-3 pl-0 pr-0" v-if="context == 'gp'">
            <div
              class="d-flex justify-content-center"
              style="padding-top: 20px; padding-bottom: 15px"
            >
              <div class="summaryFundTitle flex-row">
                Pending Distributions
                <div
                  class="link tooltip-wrapper"
                  v-tooltip="{
                    content:
                      'Sum of the unchecked distributions from the ledger',
                    class: 'mytooltip',
                  }"
                >
                  <img
                    src="static/img/graphInfo.svg"
                    style="margin-left: 15px"
                  />
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <div class="summaryFundTitle">${{ pendingDistributionFormatted }}</div>
            </div>
          </div>
          <div class="col-3 pl-0 pr-0" v-if="context == 'gp'">
            <div
              class="d-flex justify-content-center"
              style="padding-top: 20px; padding-bottom: 15px"
            >
              <div class="summaryFundTitle">Net DPI</div>
            </div>
            <div class="d-flex justify-content-center">
              <div class="summaryFundTitle">{{ netDpiValue[0].value }}</div>
            </div>
          </div>

          <div class="col-3 pl-0 pr-0" v-if="context == 'gp'">
            <div class="row value-card">
              <div class="col-12">
                <div
                  class="gp-medium-dashboard pb-1"
                  style="margin-bottom: 20px"
                >
                  Total Proceeds:
                  <b>${{ formatNumberWithComma(totalIRRProfit) }}</b>
                </div>
              </div>
              <div class="col-12">
                <div class="gp-medium-dashboard pb-1">
                  Total Cost:
                  <b>(${{ formatNumberWithComma(totalIRRCost) }})</b>
                </div>
              </div>
              <!-- <div class="col-12">
                <div class="gp-medium-dashboard pb-1">IRR</div>
                <div class="gp-medium-dashboard-value">{{ irrValue }}</div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="d-flex pb-2" style="justify-content: space-between">
          <div class="summaryCls"></div>
          <!-- <button
            class="newTask"
            @click="handleCreateDistribution"
            v-if="checkRole != 'Guest'"
            :disabled="isDisabled"
            :style="
              isDisabled
                ? 'cursor:not-allowed;color: rgb(103,103,103);border-color: rgb(103,103,103);'
                : 'cursor:pointer'
            "
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
            Add
          </button> -->
        </div>

        <div id="theMainTableDistribution">
          <div :class="'col-12'" v-if="context == 'gp'">Distributions</div>
          <div
            class="tabulator capitalCall-tabulator-cls distributionRefTableCls"
            ref="distributionRefTable"
            style="width: 100%"
          ></div>
        </div>

        <div>
          <div
            style="margin: 30px 0 10px"
            :class="'col-12'"
            v-if="context == 'gp'"
          >
            Ledger
          </div>
          <div
            class="tabulator capitalCall-tabulator-cls"
            ref="ledgerRefTable"
            style="width: 100%; height: 100%"
          ></div>

          <div class="col-12" style="margin-top: 25px">
            <button
              type="button"
              :disabled="isSelectedForDistribution"
              class="todo-form-submit-button btn btn-primary right"
              style="height: 35px"
              @click="handleDistribute()"
            >
              Distribute
            </button>
          </div>
        </div>
      </div>
    </div>

    <custom-menu></custom-menu>
    <el-dialog
      left
      :title="DistributionModalTitle"
      width="410px"
      style="margin: 0 auto"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelDistribution"
      :showClose="!showDistributionSpinner"
      :visible.sync="showDistributionModal"
      class="investment-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="handleSaveDistribution">
        <div class="row">
          <div class="col-12">
            <div class="formLabel">Last Distribution Date</div>
            <input
              class="todo-form-date todo-form form-control"
              type="date"
              :value="
                distributionDetails.last_distribution &&
                moment
                  .utc(distributionDetails.last_distribution)
                  .format('YYYY-MM-DD')
                  ? moment
                      .utc(distributionDetails.last_distribution)
                      .format('YYYY-MM-DD')
                  : moment.utc(new Date()).format('YYYY-MM-DD')
              "
              @input="
                distributionDetails.last_distribution = moment(
                  $event.target.valueAsDate
                )
              "
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="formLabel">
              Distribution
              <span class="required">*</span>
            </div>
            <input
              type="Number"
              min="0"
              step=".01"
              class="form-control team-form"
              style="width: 100%"
              v-model="distributionDetails.distributions"
              placeholder="Distribution"
              @keyup="validations"
            />
          </div>
        </div>
        <div class="edit-company-action-button-row pt-3" style="margin: 0px">
          <button
            type="button"
            @click="handleCancelDistribution()"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <!-- @click="registrarSave" -->
          <button
            type="submit"
            :disabled="showDistributionSpinner || saveDisable"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Save
            <b-spinner
              v-if="showDistributionSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
    <el-dialog
      center
      width="410px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelDelete"
      :showClose="!showDeleteSpinner"
      :visible.sync="showDeleteDialog"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div style="padding-left: 30px">
          Are you sure you want to Delete this Distribution?
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDelete"
            :disabled="showDeleteSpinner"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="handleDelete(deleteData)"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="showDeleteSpinner"
          >
            Delete
            <b-spinner
              v-if="showDeleteSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      center
      width="374px"
      title="Select Distribution Date"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :visible.sync="showDistributionDateDialog"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div>
          <div class="formLabel">Distribution Date</div>
          <input
            class="todo-form-date todo-form form-control"
            style="width: 100%"
            @input="dateOfDistribution = moment($event.target.valueAsDate)"
            type="date"
          />
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelSaveDistribution()"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="handleSaveDistributionDialog()"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="showDistributionSaveSpinner"
          >
            Save
            <b-spinner
              v-if="showDistributionSaveSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Tabulator from "tabulator-tables";
import CustomMenu from "../Components/CustomMenu.vue";
import { mapGetters } from "vuex";
import { Dialog, Select, Option } from "element-ui";
import {
  formatCurrency,
  formatNumber,
  precisionNumberForamtter,
  formatNumberWithComma,
} from "../../../util";
import config from "../../../../config/settings";

const DATA_STATUS_CONFIRMED = "Confirmed";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
const DATA_STATUS_UPDATING = "Retrieving";

export default {
  name: "DistributionsTab",
  components: {
    [CustomMenu.name]: CustomMenu,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    context: String,
  },
  watch: {
    distribution: {
      handler: function (newData) {
        this.checkDistributionIds();
      },
    },
    portfolioAll: function () {
      this.calculateIRR();
    },
    portfolioData: {
      handler: function (newData) {
        this.ledgerTabulator.replaceData(this.getLedgerData());
      },
    },
  },
  data() {
    return {
      distributionTabulator: null,
      distributionDetails: {},
      showDistributionModal: false,
      showDistributionSpinner: false,
      DistributionModalTitle: "",
      saveDisable: true,
      showDeleteSpinner: false,
      showDeleteDialog: false,
      deleteData: {},

      ledgerTabulator: null,
      dateOfDistribution: moment(new Date()).format("YYYY-MM-DD"),
      showDistributionSaveSpinner: false,
      showDistributionDateDialog: false,
      isSelectedForDistribution: true,
      selectedItems: [],
      pendingDistribution: 0,
      pendingDistributionFormatted: '',
      disableLedgerItemIds: [],

      totalIRRProfit: 0,
      totalIRRCost: 0,
      irrValue: 0,
    };
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioData", "portfolioAll"]),
    ...mapGetters("lpAllocations", ["summaryData"]),
    ...mapGetters("lpAllocations", [
      "distributionData",
      "currentDistributionData",
      "currentCapitalCallData",
      "fundDetailsData",
      "lpDetailsData",
      "detailsData",
      "capitalCallData",
    ]),
    ...mapGetters("user", ["currency"]),
    ...mapGetters("portfolio", ["portfolioData"]),
    ...mapGetters("role", ["checkRole"]),
    formatNumberWithComma() {
      return formatNumberWithComma;
    },
    distribution() {
      let self = this;
      return {
        data: this.distributionData,
        layout: "fitColumns",
        height: "100%",
        tooltips: true,
        layoutColumnsOnNewData: true,
        // index: "_id",
        tooltips: true,
        tooltipsHeader: true,
        placeholder: "No records to view",
        columns: this.distributionTableColumns,
        responsiveLayout: "collapse",
        responsiveLayoutCollapseStartOpen: false,
        responsiveLayoutCollapseFormatter: function (item) {
          //data - an array of objects containing the column title and value for each cell

          let container = document.createElement("div");

          container.setAttribute("id", "someId");
          container.innerHTML = "aaa";
          return container;
        },
        rowClick: function (e, row) {
          var collapse = row
            .getElement()
            .getElementsByClassName("tabulator-responsive-collapse")[0];

          let el = row.getElement();

          if (!el.classList.contains("open")) {
            el.classList.add("open");

            let innerTabulatorContainer = el.querySelector("#someId");

            let tabulatorData = self.getLedgerData(row.getData().ledger);

            new Tabulator(innerTabulatorContainer, {
              data: tabulatorData,
              layout: "fitColumns",
              tooltips: true,
              height: "100%",
              layoutColumnsOnNewData: true,
              placeholder: "No records to view",
              columns: self.ledgerTableColumnsInner,
            });

            if (collapse) {
              collapse.style.display = "";
            }
          } else {
            el.classList.remove("open");
            if (collapse) {
              collapse.style.display = "none";
            }
          }
        },
      };
    },
    distributionTableColumns() {
      const self = this;

      let handleMenu = function (_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [
            {
              title: "Edit",
              handler: () => {
                let data = _cell.getData();
                self.handleUpdateDistribution(data);
              },
            },
            {
              title: "Delete",
              handler: () => {
                let data = _cell.getData();
                self.deleteData = data;
                self.showDeleteDialog = true;
              },
            },
          ];
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-v" style="color:#0000004D;"></i>
        `;
      };
      return [
        {
          title: "Distribution No.",
          field: "current_distribution",
          headerSort: false,
          resizable: true,
          // bottomCalc: function (values, data, calcParams) {
          //   //values - array of column values
          //   //data - all table data
          //   //calcParams - params passed from the column definition object
          //   return "TOTALS";
          // },
        },
        {
          title: "Date",
          field: "last_distribution",
          headerSort: false,
          resizable: true,
          formatter: function (cell, formatterParams) {
            return moment(cell.getData().last_distribution).format(
              "MM/DD/YYYY"
            );
          },
          tooltip: false,
        },
        {
          title: "Amount",
          field: "distributions",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          width: "45",
          resizable: false,
          headerSort: false,
          responsive: 0,
          download: false,
          formatter: function (_cell, formatterParams) {
            if (self.checkRole == "Guest") {
              return "";
            }
            if (
              _cell.getData() &&
              _cell.getData().hasOwnProperty("showEllipses") &&
              _cell.getData().showEllipses == true
            ) {
              // return handleMenu(_cell, formatterParams, formatterParams);
              return `<span
                  @click=""
                  class="fa fa-trash pointer"
                ></span>`;
            } else {
              return "";
            }
          },
          cellClick: function (e, cell) {
            if (e.target.tagName == "SPAN") {
              let data = cell.getData();
              self.deleteData = data;
              self.showDeleteDialog = true;
            }
          },
        },
      ];
    },
    moment() {
      return moment;
    },
    totalDistributions() {
      let data = JSON.parse(JSON.stringify(this.distributionData));
      let retval = 0;
      if (data && data.length > 0) {
        data.map((item) => {
          if (
            item &&
            item.hasOwnProperty("distributions") &&
            Number(item.distributions) > 0
          ) {
            retval += Number(item.distributions);
          }
        });
      }
      return retval > 0 ? ` $${precisionNumberForamtter(retval, 1)}` : 0;
    },
    isDisabled() {
      return this.capitalCallData && this.capitalCallData.length > 0
        ? false
        : true;
    },
    portfolioValue() {
      // sum up our portfolio value
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.value)) sum += item.value;
        });
      }
      return sum;
    },
    portfolioCost() {
      // sum up our porfolio cost
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.cost)) sum += item.cost;
        });
      }
      return sum;
    },
    moicValue() {
      return this.portfolioCost && this.portfolioCost > 0
        ? Number(
            (Number(this.portfolioValue) / Number(this.portfolioCost)).toFixed(
              2
            )
          )
        : 0;
    },
    netDpiValue() {
      let data = this.summaryData;
      let retval = [
        {
          label: "Net DPI : ",
          value:
            data &&
            data.length > 0 &&
            data[0].hasOwnProperty("net_dpi") &&
            Number(data[0].net_dpi) > 0
              ? Number(Number(data[0].net_dpi).toFixed(2))
              : 0,
        },
        {
          label: "Gross DPI : ",
          value:
            data &&
            data.length > 0 &&
            data[0].hasOwnProperty("gross_dpi") &&
            Number(data[0].gross_dpi) > 0
              ? Number(Number(data[0].gross_dpi).toFixed(2))
              : 0,
        },
      ];
      return retval;
    },

    ledgerData() {
      let self = this;
      return {
        data: this.getLedgerData(),
        layout: "fitColumns",
        tooltips: true,
        layoutColumnsOnNewData: true,
        // index: "_id",
        tooltips: true,
        tooltipsHeader: true,
        placeholder: "No records to view",
        columns: this.ledgerTableColumns,
        rowSelectionChanged: function (data, rows) {
          self.isSelectedForDistribution = !rows.length;
          self.selectedItems = data;
        },
        selectableCheck: function (row) {
          return !self.disableLedgerItemIds.includes(row.getData()._id);
        },
      };
    },
    ledgerTableColumns() {
      const self = this;

      return [
        {
          title: "Company Name",
          field: "nameLogoString",
          formatter: "html",
          tooltip: function (cell) {
            let tootipData = `${cell._cell.row.data.name} - ${cell._cell.row.data.status}`;
            return tootipData;
          },
          cellClick: function (e, cell) {
            if (
              [DATA_STATUS_CONFIRMED, DATA_STATUS_UPDATING].indexOf(
                cell.getData()["data_status"]
              ) == -1
            ) {
              return;
            }
            // set the 'current company' and go to the company profile
            let name = cell.getData().name;
            // get the ucid
            let ucid = _.reduce(
              self.portfolioData,
              (memo, data) => {
                if (data.name == name) return data.ucid;
                return memo;
              },
              -1
            );
            // save our current company and go to the profile page
            self.$store.commit("temp/currentCompany", ucid);
            self.$router.push(
              `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${ucid}`
            );
          },
        },
        {
          title: "Date Of Proceeds",
          field: "date_of_proceeds",
          headerSort: false,
          resizable: true,
          formatter: function (cell, formatterParams) {
            return moment(cell.getData().date_of_proceeds).format("MM/DD/YYYY");
          },
          tooltip: false,
        },
        {
          title: "Amount",
          field: "distributed",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
          // bottomCalc: "sum",
          // bottomCalcFormatter: "money",
          // bottomCalcFormatterParams: this.currency.format,
          // bottomCalcParams: { precision: 2 },
        },
        {
          title: "Distributed",
          formatter: "rowSelection",
          align: "center",
          width: "90",
          headerSort: false,
          cellClick: function (e, cell) {
            cell.getRow().toggleSelect();
          },
          formatter: function (cell, formatterParams) {
            let cellData = cell.getData();

            return `<input type="checkbox" ${
              self.disableLedgerItemIds.includes(cellData._id)
                ? "checked disabled"
                : ""
            }>`;
          },
        },
      ];
    },

    ledgerTableColumnsInner() {
      const self = this;

      return [
        {
          title: "Company Name",
          field: "nameLogoString",
          formatter: "html",
          tooltip: function (cell) {
            let tootipData = `${cell._cell.row.data.name} - ${cell._cell.row.data.status}`;
            return tootipData;
          },
          cellClick: function (e, cell) {
            if (
              [DATA_STATUS_CONFIRMED, DATA_STATUS_UPDATING].indexOf(
                cell.getData()["data_status"]
              ) == -1
            ) {
              return;
            }
            // set the 'current company' and go to the company profile
            let name = cell.getData().name;
            // get the ucid
            let ucid = _.reduce(
              self.portfolioData,
              (memo, data) => {
                if (data.name == name) return data.ucid;
                return memo;
              },
              -1
            );
            // save our current company and go to the profile page
            self.$store.commit("temp/currentCompany", ucid);
            self.$router.push(
              `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${ucid}`
            );
          },
        },
        {
          title: "Date Of Proceeds",
          field: "date_of_proceeds",
          headerSort: false,
          resizable: true,
          formatter: function (cell, formatterParams) {
            return moment(cell.getData().date_of_proceeds).format("MM/DD/YYYY");
          },
          tooltip: false,
        },
        {
          title: "Amount",
          field: "distributed",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
          // bottomCalc: "sum",
          // bottomCalcFormatter: "money",
          // bottomCalcFormatterParams: this.currency.format,
          // bottomCalcParams: { precision: 2 },
        },
      ];
    },
  },
  mounted() {
    if (this.$refs.distributionRefTable && this.distribution) {
      this.distributionTabulator = new Tabulator(
        this.$refs.distributionRefTable,
        this.distribution
      );

      this.loadLedgerGrid();
    }

    this.checkDistributionIds();

    this.calculateIRR();
  },
  methods: {
    checkDistributionIds() {
      if (this.distributionTabulator) {
        this.disableLedgerItemIds = [];
        this.distribution.data.forEach((item) => {
          item.ledger.forEach((l) => {
            this.disableLedgerItemIds.push(l._id);
          });
        });
        this.distributionTabulator.replaceData(this.distribution.data);
        this.ledgerTabulator.replaceData(this.getLedgerData());
      }
    },
    refreshDistributionData() {
      const self = this;
      let data = self.$store.getters["lpAllocations/distributionData"];
      if (data && data.length > 0) this.distributionTabulator.replaceData(data);
    },
    handleCancelDistribution() {
      this.distributionDetails = {};
      this.showDistributionModal = false;
      this.showDistributionSpinner = false;
      this.DistributionModalTitle = "";
      this.saveDisable = true;
    },
    handleSaveDistribution() {
      const self = this;
      this.showDistributionSpinner = true;
      let serverData = JSON.parse(JSON.stringify(this.distributionDetails));
      serverData.distributions = Number(serverData.distributions);
      if (this.DistributionModalTitle == "Add Distributions") {
        serverData.distributed_to_date =
          self.currentDistributionData &&
          self.currentDistributionData.hasOwnProperty("distributed_to_date") &&
          Number(self.currentDistributionData.distributed_to_date) > 0
            ? Number(self.currentDistributionData.distributed_to_date) +
              Number(serverData.distributions)
            : Number(serverData.distributions);
      } else {
        let previousDistributionToDateValue =
          self.currentDistributionData &&
          self.currentDistributionData.hasOwnProperty("distributed_to_date") &&
          Number(self.currentDistributionData.distributed_to_date) > 0
            ? Number(self.currentDistributionData.distributed_to_date)
            : 0;
        let previousDistributionsValue =
          self.currentDistributionData &&
          self.currentDistributionData.hasOwnProperty("distributions") &&
          Number(self.currentDistributionData.distributions) > 0
            ? Number(self.currentDistributionData.distributions)
            : 0;
        let presentDistributionsToDateValue = Number(
          (
            Number(previousDistributionToDateValue) -
            Number(previousDistributionsValue)
          ).toFixed(2)
        );
        serverData.distributed_to_date = Number(
          (
            Number(presentDistributionsToDateValue) +
            Number(serverData.distributions)
          ).toFixed(2)
        );
      }
      serverData.current_distribution =
        this.DistributionModalTitle == "Add Distributions"
          ? `Dist#${self.distributionData.length + 1}`
          : serverData.current_distribution;
      serverData.last_distribution = serverData.last_distribution
        ? serverData.last_distribution
        : new Date();
      serverData.current_capital_call =
        self.currentCapitalCallData &&
        self.currentCapitalCallData.hasOwnProperty("_id")
          ? self.currentCapitalCallData._id
          : "";
      serverData.distributions_in_carry =
        self.fundDetailsData &&
        self.fundDetailsData.length > 0 &&
        self.fundDetailsData[0].hasOwnProperty("capital_commitment") &&
        Number(self.fundDetailsData[0].capital_commitment)
          ? Number(
              (
                Number(serverData.distributed_to_date) -
                Number(self.fundDetailsData[0].capital_commitment)
              ).toFixed(2)
            )
          : 0;
      serverData.distributions_pre_carry = Number(
        (
          Number(serverData.distributed_to_date) -
          Number(serverData.distributions_in_carry)
        ).toFixed(2)
      );
      let url =
        this.DistributionModalTitle == "Add Distributions"
          ? "lpAllocations/apiPostDistributionData"
          : "lpAllocations/apiPatchDistributionData";
      self.$store
        .dispatch(url, serverData)
        .then((data) => {
          self
            .updateDetailsData()
            .then((updateDetailsData) => {
              self
                .updateKpi()
                .then((updateKpiData) => {
                  self.refreshDistributionData();
                  self
                    .updateSummaryData()
                    .then((updateSummaryData) => {
                      self.handleCancelDistribution();
                      self.$toaster.success("Saved Successfully");
                    })
                    .catch((error) => {
                      console.log(
                        "error in updateSummaryData in updateKpi in updateDetailsData in distribution insert",
                        error
                      );
                      this.$toaster.error("Fail to Insert!!!");
                    });
                })
                .catch((error) => {
                  console.log(
                    "error in updateKpi in updateDetailsData in distribution insert",
                    error
                  );
                  this.$toaster.error("Fail to Insert!!!");
                });
            })
            .catch((error) => {
              console.log(
                "error in updateDetailsData in distribution insert",
                error
              );
              this.$toaster.error("Fail to Insert!!!");
            });
        })
        .catch((error) => {
          console.log("error in distribution insert", error);
          this.$toaster.error("Fail to Insert!!!");
        });
    },
    validations() {
      if (
        this.distributionDetails &&
        this.distributionDetails.hasOwnProperty("distributions") &&
        Number(this.distributionDetails.distributions) > 0
      ) {
        this.saveDisable = false;
      } else {
        this.saveDisable = true;
      }
    },
    handleCreateDistribution() {
      this.DistributionModalTitle = "Add Distributions";
      this.distributionDetails = {};
      this.validations();
      this.showDistributionModal = true;
    },
    handleUpdateDistribution(rowData) {
      this.DistributionModalTitle = "Edit Distributions";
      this.distributionDetails = JSON.parse(JSON.stringify(rowData));
      this.validations();
      this.showDistributionModal = true;
    },
    updateDetailsData() {
      const self = this;
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let distributionData =
        self.$store.getters["lpAllocations/distributionData"];
      let payload = [];
      return new Promise((resolve, reject) => {
        let capitalCommitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment)
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        if (detailsData && detailsData.length > 0) {
          detailsData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership)
                ? Number(item.ownership)
                : 0;
            let profit =
              item.hasOwnProperty("profit") && Number(item.profit)
                ? Number(item.profit)
                : 0;
            if (
              currentDistributionData &&
              currentDistributionData.hasOwnProperty("distributions") &&
              currentDistributionData.hasOwnProperty(
                "distributions_pre_carry"
              ) &&
              currentDistributionData.hasOwnProperty(
                "distributions_in_carry"
              ) &&
              Number(currentDistributionData.distributions) > 0 &&
              Number(currentDistributionData.distributions_pre_carry) &&
              Number(currentDistributionData.distributions_in_carry)
            ) {
              if (
                currentDistributionData.hasOwnProperty("distributed_to_date") &&
                capitalCommitment &&
                Number(capitalCommitment) &&
                Number(currentDistributionData.distributed_to_date) >
                  Number(capitalCommitment)
              ) {
                //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                item.distributions = Number(
                  (
                    Number(currentDistributionData.distributions_pre_carry) *
                      (Number(ownership) / 100) +
                    Number(currentDistributionData.distributions_in_carry) *
                      (Number(profit) / 100)
                  ).toFixed(2)
                );
              } else {
                //distrubutions=distributed to date of summary*ownership%
                item.distributions =
                  (item.entity_type == "LP" || item.entity_type == "GP") &&
                  Number(currentDistributionData.distributed_to_date) > 0 &&
                  Number(ownership) > 0
                    ? Number(
                        (
                          Number(currentDistributionData.distributed_to_date) *
                          Number(Number(ownership) / 100)
                        ).toFixed(2)
                      )
                    : 0;
              }
            } else {
              if (distributionData && distributionData.length == 0) {
                item.distributions = 0;
              }
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateKpi() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let lpDetailsData = self.$store.getters["lpAllocations/lpDetailsData"];
      return new Promise((resolve, reject) => {
        let payload = JSON.parse(JSON.stringify(currentCapitalCallData));
        let totalLpCapitalCalled = 0;
        let totalLpDistributions = 0;
        let totalFundCapitalCalled =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_called") &&
          Number(fundDetailsData[0].capital_called) > 0
            ? Number(fundDetailsData[0].capital_called)
            : 0;
        let totalFundDistributions =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("distributions") &&
          Number(fundDetailsData[0].distributions) > 0
            ? Number(fundDetailsData[0].distributions)
            : 0;
        if (lpDetailsData && lpDetailsData.length > 0) {
          lpDetailsData.map((item) => {
            if (
              item &&
              item.hasOwnProperty("capital_called") &&
              Number(item.capital_called) > 0
            ) {
              totalLpCapitalCalled += Number(item.capital_called);
            }
            if (
              item &&
              item.hasOwnProperty("distributions") &&
              Number(item.distributions) > 0
            ) {
              totalLpDistributions += Number(item.distributions);
            }
          });
          payload.net_dpi =
            Number(totalLpCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalLpDistributions) / Number(totalLpCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          payload.gross_dpi =
            Number(totalFundCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalFundDistributions) /
                    Number(totalFundCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          if (payload.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchCapitalCallData", payload)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    updateSummaryData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        let serverData =
          self.summaryData && self.summaryData.length > 0
            ? JSON.parse(JSON.stringify(self.summaryData[0]))
            : {};
        serverData.net_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("net_dpi") &&
          Number(currentCapitalCallData.net_dpi) > 0
            ? Number(currentCapitalCallData.net_dpi)
            : 0;
        serverData.gross_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("gross_dpi") &&
          Number(currentCapitalCallData.gross_dpi) > 0
            ? Number(currentCapitalCallData.gross_dpi)
            : 0;
        serverData.capital_commitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment) > 0
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        serverData.distributions =
          currentDistributionData.hasOwnProperty("distributions") &&
          Number(currentDistributionData.distributions)
            ? Number(currentDistributionData.distributions)
            : 0;
        serverData.distributions_pre_carry =
          currentDistributionData.hasOwnProperty("distributions_pre_carry") &&
          Number(currentDistributionData.distributions_pre_carry)
            ? Number(currentDistributionData.distributions_pre_carry)
            : 0;
        serverData.distributions_in_carry =
          currentDistributionData.hasOwnProperty("distributions_in_carry") &&
          Number(currentDistributionData.distributions_in_carry)
            ? Number(currentDistributionData.distributions_in_carry)
            : 0;
        serverData.distributed_to_date =
          currentDistributionData.hasOwnProperty("distributed_to_date") &&
          Number(currentDistributionData.distributed_to_date)
            ? Number(currentDistributionData.distributed_to_date)
            : 0;
        serverData.current_distribution =
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
            ? currentDistributionData._id
            : "";
        if (self.summaryData && self.summaryData.length > 0) {
          if (serverData && serverData.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchSummaryData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          self.$store
            .dispatch("lpAllocations/apiPostSummaryData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    handleCancelDelete() {
      this.showDeleteSpinner = false;
      this.showDeleteDialog = false;
      this.deleteData = {};
    },
    handleDelete(serverData) {
      const self = this;
      if (serverData && serverData.hasOwnProperty("_id")) {
        this.showDeleteSpinner = true;
        self.$store
          .dispatch("lpAllocations/apiDeleteDistributionData", serverData)
          .then((deleteData) => {
            self.$store
              .dispatch("lpAllocations/apiFetchDistributionData")
              .then((data) => {
                self
                  .updateDetailsData()
                  .then((updateDetailsData) => {
                    self
                      .updateKpi()
                      .then((updateKpiData) => {
                        self.refreshDistributionData();
                        self
                          .updateSummaryData()
                          .then((updateSummaryData) => {
                            self.handleCancelDelete();
                            self.$toaster.success("Deleted Successfully");
                          })
                          .catch((error) => {
                            console.log(
                              "error in updateSummaryData in updateKpi in updateDetailsData in distribution Delete",
                              error
                            );
                            this.$toaster.error("Fail to Delete!!!");
                          });
                      })
                      .catch((error) => {
                        console.log(
                          "error in updateKpi in updateDetailsData in distribution Delete",
                          error
                        );
                        this.$toaster.error("Fail to Delete!!!");
                      });
                  })
                  .catch((error) => {
                    console.log(
                      "error in updateDetailsData in distribution delete",
                      error
                    );
                    this.$toaster.error("Fail to Delete!!!");
                  });
              })
              .catch((error) => {
                console.log(
                  "error in distributions fetch in deleting distribution",
                  error
                );
                this.$toaster.error("Failed to delete!!!");
              });
          })
          .catch((error) => {
            console.log("error in deleting distribution", error);
            this.$toaster.error("Failed to delete!!!");
          });
      }
    },

    getLedgerData(cData) {
      const self = this;

      let companyData = cData || self.portfolioData;

      if (!cData) {
        self.pendingDistribution = 0;
      }

      let items = _.map(companyData, (data, index) => {
        if (Number.isInteger(data.cost)) {
          self.totalCapitalDeployed += data.cost;
        }

        if (["IPO", "Acquired"].includes(data.status)) {
          if (data.ipo_info || data.acquisition_info) {
            if (
              data.ipo_info &&
              data.ipo_info.ipoRecycled &&
              data.ipo_info.ipoRecycled > 0
            ) {
              self.totalMoneyRecycled += parseInt(data.ipo_info.ipoRecycled);
            }
            if (
              data.acquisition_info &&
              data.acquisition_info.acquisitionRecycle &&
              data.acquisition_info.acquisitionRecycle > 0
            ) {
              self.totalMoneyRecycled += parseInt(
                data.acquisition_info.acquisitionRecycle
              );
            }
          }

          if (data.ipo_info) {
            data.distributedAmount = data.ipo_info.ipoDistribution
              ? data.ipo_info.ipoDistribution
              : 0;

            data.distributed =
              "$" + formatNumberWithComma(data.distributedAmount);
            data.date_of_proceeds = data.ipo_info.ipoDateSold;
          } else if (data.acquisition_info) {
            data.distributedAmount = data.acquisition_info
              .acquisitionDistribution
              ? data.acquisition_info.acquisitionDistribution
              : 0;

            data.distributed =
              "$" + formatNumberWithComma(data.distributedAmount);
            data.date_of_proceeds =
              data.acquisition_info.acquisitionTransactionDate;
          } else {
            data.distributedAmount = 0;
            data.distributed = "$" + 0;
            data.date_of_proceeds = "-";
          }

          if (!cData) {
            if (
              !self.disableLedgerItemIds.includes(data._id) &&
              data.distributedAmount
            ) {
              self.pendingDistribution += parseFloat(data.distributedAmount);
            }
          }
        }

        if (!cData) {
          self.pendingDistributionFormatted = precisionNumberForamtter(
            self.pendingDistribution,
            1
          );
        }

        data.id = index;
        let logoUrl =
          data.hasOwnProperty("image_id") && data.image_id.length > 0
            ? `${config.CRUNCHBASE_IMAGE_URL}/${data.image_id}`
            : data.logo_url;
        if (data.data_status == DATA_STATUS_CONFIRMED) {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/confirmed.svg" class="company-statys-img"/>
                            <b style="margin-left: 48px;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            }  </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>

            `;
        }
        if (data.data_status == DATA_STATUS_UNCONFIRMED) {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/warning.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            } </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>
            `;
        }
        if (data.data_status == DATA_STATUS_UPDATING) {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/retrieving.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            } </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>
            `;
        }
        if (data.data_status == "NoCompanyUrl") {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/warning.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            } </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>
            `;
        }

        return data;
      });

      return items.filter((item) => {
        return ["IPO", "Acquired"].includes(item.status);
        // return item.ipo_info || item.acquisition_info;
      });
    },

    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },

    handleDistribute() {
      this.showDistributionDateDialog = true;
    },
    handleCancelSaveDistribution() {
      this.showDistributionDateDialog = false;
      this.showDistributionSaveSpinner = false;
    },
    handleSaveDistributionDialog() {
      const self = this;
      self.showDistributionSaveSpinner = true;

      let distributionTotal = 0;
      self.selectedItems.forEach((item) => {
        distributionTotal += parseFloat(item.distributedAmount);
      });

      let serverData = {
        distributions: distributionTotal,
        ledger: self.selectedItems,
      };
      serverData.distributions = Number(serverData.distributions);
      serverData.last_distribution = new Date(
        self.dateOfDistribution
      ).toISOString();

      serverData.distributed_to_date =
        self.currentDistributionData &&
        self.currentDistributionData.hasOwnProperty("distributed_to_date") &&
        Number(self.currentDistributionData.distributed_to_date) > 0
          ? Number(self.currentDistributionData.distributed_to_date) +
            Number(serverData.distributions)
          : Number(serverData.distributions);

      serverData.current_distribution = `Distribution#${
        self.distributionData.length + 1
      }`;

      serverData.current_capital_call =
        self.currentCapitalCallData &&
        self.currentCapitalCallData.hasOwnProperty("_id")
          ? self.currentCapitalCallData._id
          : "";

      serverData.distributions_in_carry =
        self.fundDetailsData &&
        self.fundDetailsData.length > 0 &&
        self.fundDetailsData[0].hasOwnProperty("capital_commitment") &&
        Number(self.fundDetailsData[0].capital_commitment)
          ? Number(
              (
                Number(serverData.distributed_to_date) -
                Number(self.fundDetailsData[0].capital_commitment)
              ).toFixed(2)
            )
          : 0;

      serverData.distributions_pre_carry = Number(
        (
          Number(serverData.distributed_to_date) -
          Number(serverData.distributions_in_carry)
        ).toFixed(2)
      );

      let url = "lpAllocations/apiPostDistributionData";

      self.$store
        .dispatch(url, serverData)
        .then((data) => {
          self
            .updateDetailsData()
            .then((updateDetailsData) => {
              self
                .updateKpi()
                .then((updateKpiData) => {
                  self.refreshDistributionData();
                  self
                    .updateSummaryData()
                    .then((updateSummaryData) => {
                      self.handleCancelSaveDistribution();
                      self.$toaster.success("Saved Successfully");
                    })
                    .catch((error) => {
                      console.log(
                        "error in updateSummaryData in updateKpi in updateDetailsData in distribution insert",
                        error
                      );
                      this.$toaster.error("Fail to Insert!!!");
                    });
                })
                .catch((error) => {
                  console.log(
                    "error in updateKpi in updateDetailsData in distribution insert",
                    error
                  );
                  this.$toaster.error("Fail to Insert!!!");
                });
            })
            .catch((error) => {
              console.log(
                "error in updateDetailsData in distribution insert",
                error
              );
              this.$toaster.error("Fail to Insert!!!");
            });
        })
        .catch((error) => {
          console.log("error in distribution insert", error);
          this.$toaster.error("Fail to Insert!!!");
        });
    },

    loadLedgerGrid() {
      if (this.$refs.ledgerRefTable && this.ledgerData) {
        this.ledgerTabulator = new Tabulator(
          this.$refs.ledgerRefTable,
          this.ledgerData
        );
      }
    },

    calculateIRR() {
      let self = this;
      let dates = [];
      let values = [];

      self.totalIRRProfit = 0;
      self.totalIRRCost = 0;

      self.portfolioAll.map((portfolioItem, index) => {
        let investmentData = self.$store.getters[
          "investment/investmentsByPortfolioId"
        ](portfolioItem._id, portfolioItem.workspace);
        let investment = JSON.parse(JSON.stringify(investmentData));

        investment.map((item) => {
          item.portfolio_item = portfolioItem._id;
          item.investment_type = item.investment_type
            ? item.investment_type
            : "Unknown";

          if (!item.transaction_type) item.transaction_type = "Investment";

          if (item.date) item.date = moment(item.date).format("MM/DD/YYYY");
          else if (item.transaction_date)
            item.date = moment(item.transaction_date).format("MM/DD/YYYY");
          else item.date = "-";

          if (item.investment_type === "Unknown") {
            item.investment_type = "-";
          }

          if (item.investment_type == "Proceeds") {
            self.totalIRRProfit += parseFloat(
              item.amount || item.proceeds_amount || 0
            );
            values.push(parseFloat(item.amount || item.proceeds_amount || 0));
          } else {
            self.totalIRRCost += parseFloat(item.amount);
            values.push(item.amount * -1);
          }

          dates.push(moment(item.date, "MM/DD/YYYY"));
        });
      });

      window.moment = moment;
      let val = XIRR(values, dates) * 100;

      if (!isNaN(val)) {
        self.irrValue = parseFloat(val).toFixed(2);
      } else {
        self.irrValue = "-";
      }
    },
  },
};
</script>

<style>
.distributionRefTableCls .tabulator-responsive-collapse {
  margin-left: 20px;
  padding: 0px;
  padding-top: 5px;
}
</style>